import { ETripStatus } from '../../repositories/dailyrent/entities/response/TripStatusStep';
import { ENewReviewFlow } from '../../types/newReview';

/**
 * Маппит статус поездки (ETripStatus) в flow отзыва (ENewReviewFlow)
 */
export function mapTripStatusToFlow(tripStatus: ETripStatus | null | undefined): ENewReviewFlow | null {
  if (!tripStatus) {
    return null;
  }

  const tripStatusToFlowMap: Record<ETripStatus, ENewReviewFlow> = {
    [ETripStatus.Success]: ENewReviewFlow.Success,
    [ETripStatus.Fail]: ENewReviewFlow.Fail,
    [ETripStatus.FailedToAgree]: ENewReviewFlow.FailedToAgree,
    [ETripStatus.Plan]: ENewReviewFlow.Success, // Plan маппим в Success по умолчанию
  };

  return tripStatusToFlowMap[tripStatus] || null;
}
